import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Nav, Navbar, NavItem, NavDropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import logo from '../../images/ogc-logo.png';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import NavUserActions from './NavUserActions';
import { UserRoles } from '../shared/enums';
import { BlankOrderGuideGroup } from '../shared/consts';

class NavMenu extends Component {
    displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.state = {
            orderGuideGroup:  BlankOrderGuideGroup
        };
    }

    componentDidMount = async (props) => {
        if (this.props.isAuthenticated) {
            const fetchConfig = {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            };
            const response = await fetch('api/OrderGuideGroups/settings', fetchConfig);
            if (response.ok) {
                let data = await response.json();

                this.setState({ orderGuideGroup: (data && data.orderGuideGroup) ? data.orderGuideGroup : BlankOrderGuideGroup });
            }
            else {
                console.log("Error retrieving Order Guide Groups: " + await response.text());
            }
        }
    }

    render() {
        const allowSameDays = this.props.allowSameDayDeliveries || this.state.orderGuideGroup.allowSameDayDeliveries;

        return (
            <Navbar collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to={'/'}><img src={logo} alt="" /></Link>
                    </Navbar.Brand>
                    {this.props.isAuthenticated &&
                        <Navbar.Toggle />
                    }

                </Navbar.Header>
                <div className="nav-body">
                    <NavUserActions {...this.props} />
                    <Navbar.Collapse>
                        <Nav pullRight>
                        {this.props.isAuthenticated && (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep) &&
                            <React.Fragment>
                                <NavDropdown title="Manage" id="dropdownManage">
                                    <LinkContainer to={'/Admin/Users'}>
                                        <NavItem>Users</NavItem>
                                    </LinkContainer>
                                    <LinkContainer to={'/Admin/OrderGuideGroup'}>
                                        <NavItem>Order Guide Settings</NavItem>
                                    </LinkContainer>
                                    <LinkContainer to={'/Home/Edit'}>
                                        <NavItem>Edit Home</NavItem>
                                    </LinkContainer>
                                </NavDropdown>

                                <LinkContainer to={'/OrderGuide'}>
                                    <NavItem>Order Guide</NavItem>
                                </LinkContainer>
                                <LinkContainer to={'/SODashboard'}>
                                    <NavItem>SO Dashboard</NavItem>
                                </LinkContainer>
                                {/*<LinkContainer to={'/Analytics'}>
                                    <NavItem>Analytics</NavItem>
                                </LinkContainer>*/}
                            </React.Fragment>
                        }
                        {this.props.isAuthenticated && (this.props.userRole === UserRoles.GroupStoreBuyer || this.props.userRole === UserRoles.StoreBuyer || this.props.userRole === UserRoles.SalesRep) &&
                            <React.Fragment>
                                {this.props.userRole !== UserRoles.SalesRep &&
                                    <LinkContainer to={'/Report/SOHistory'}>
                                        <NavItem>Reports</NavItem>
                                    </LinkContainer>
                                }
                                <NavDropdown title="Sales Order" id="dropdownSalesOrder">
                                    <LinkContainer to={'/CreateSalesOrder'}>
                                        <NavItem>Create Sales Order</NavItem>
                                    </LinkContainer>
                                    {allowSameDays &&
                                        <LinkContainer to={'/CreateSameDaySalesOrder'}>
                                            <NavItem>Create Same Day Sales Order</NavItem>
                                        </LinkContainer>
                                    }
                                    {(this.props.userRole === UserRoles.GroupStoreBuyer || this.props.userRole === UserRoles.SalesRep)  &&
                                        <LinkContainer to={'/CreateSalesOrderGroup'}>
                                            <NavItem>Group Order Screen</NavItem>
                                        </LinkContainer>
                                    }
                                </NavDropdown>
                            </React.Fragment>
                        }
                        </Nav>    
                    </Navbar.Collapse>
                </div>
            </Navbar>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(NavMenu));


// WEBPACK FOOTER //
// ./src/components/Nav/NavMenu.js